import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  useColorScheme,
  StyleSheet,
  Dimensions,
  FlatList,
  Image,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ProgressChart, LineChart } from 'react-native-chart-kit';

const screenWidth = Dimensions.get('window').width;

const FoodRecommendationScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const [activeTab, setActiveTab] = useState('overview');

  // 模拟数据 - 在实际项目中应从API或本地存储获取
  const [nutritionData, setNutritionData] = useState({
    // 总体营养数据
    overallData: {
      caloriesGoal: 2000,
      caloriesConsumed: 1820,
      proteinPercentage: 0.85,
      carbsPercentage: 0.88,
      fatPercentage: 0.71,
      fiberPercentage: 0.65,
      weeklyHabits: {
        regularMeals: 0.8,
        mealVariety: 0.7,
        hydration: 0.9,
        lateNightEating: 0.4,
      },
      healthRisks: [
        { title: '高钠饮食', severity: 'moderate', description: '连续三天钠摄入超标准' },
        { title: '维生素D不足', severity: 'high', description: '本周维生素D摄入只达到推荐量的40%' },
      ],
    },
    // 周趋势数据
    weeklyData: {
      calories: [1850, 1920, 1750, 1680, 2050, 1990, 1820],
      protein: [92, 88, 80, 78, 95, 90, 85], 
      carbs: [220, 240, 210, 200, 250, 235, 220],
      fat: [58, 62, 55, 50, 68, 65, 60],
    },
    // 推荐食物
    recommendedFoods: [
      { id: '1', name: '三文鱼', benefit: '富含优质蛋白质和Omega-3脂肪酸', image: 'https://via.placeholder.com/60' },
      { id: '2', name: '菠菜', benefit: '补充维生素K和叶酸', image: 'https://via.placeholder.com/60' },
      { id: '3', name: '全麦面包', benefit: '提供膳食纤维和B族维生素', image: 'https://via.placeholder.com/60' },
      { id: '4', name: '酸奶', benefit: '钙质来源，有益肠道健康', image: 'https://via.placeholder.com/60' },
    ],
  });

  return (
    <ScrollView
      style={{
        flex: 1,
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}
      contentContainerStyle={{ padding: 16 }}
    >
      {/* 顶部标签栏 */}
      <View style={{
        flexDirection: 'row',
        backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
        borderRadius: 16,
        padding: 4,
        marginBottom: 20,
      }}>
        <TouchableOpacity
          style={{
            flex: 1,
            padding: 12,
            borderRadius: 12,
            backgroundColor: activeTab === 'overview' 
              ? (isDarkMode ? '#2563eb' : '#3b82f6') 
              : 'transparent',
            alignItems: 'center',
          }}
          onPress={() => setActiveTab('overview')}
        >
          <Text style={{
            color: activeTab === 'overview' ? 'white' : (isDarkMode ? 'white' : '#1f2937'),
            fontWeight: 'bold',
          }}>
            总体建议
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity
          style={{
            flex: 1,
            padding: 12,
            borderRadius: 12,
            backgroundColor: activeTab === 'details' 
              ? (isDarkMode ? '#2563eb' : '#3b82f6') 
              : 'transparent',
            alignItems: 'center',
          }}
          onPress={() => setActiveTab('details')}
        >
          <Text style={{
            color: activeTab === 'details' ? 'white' : (isDarkMode ? 'white' : '#1f2937'),
            fontWeight: 'bold',
          }}>
            具体建议
          </Text>
        </TouchableOpacity>
      </View>

      {/* 根据选择的标签展示不同内容 */}
      {activeTab === 'overview' ? renderOverviewTab() : renderDetailsTab()}
    </ScrollView>
  );

  // 渲染总体建议标签内容
  function renderOverviewTab() {
    const { overallData, weeklyData } = nutritionData;
    
    return (
      <View>
        {/* 卡路里摄入目标达成度 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            每日卡路里摄入目标达成度
          </Text>
          
          <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>
            <View style={{ flex: 1 }}>
              <Text style={{
                fontSize: 16,
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
                marginBottom: 4,
              }}>
                今日摄入: {overallData.caloriesConsumed} 千卡
              </Text>
              <Text style={{
                fontSize: 16,
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                目标摄入: {overallData.caloriesGoal} 千卡
              </Text>
            </View>
            
            <View style={{ width: 80, height: 80 }}>
              <ProgressChart
                data={{
                  data: [overallData.caloriesConsumed / overallData.caloriesGoal]
                }}
                width={80}
                height={80}
                strokeWidth={10}
                radius={32}
                chartConfig={{
                  backgroundGradientFrom: isDarkMode ? '#8fa0c1' : '#f0f9ff',
                  backgroundGradientTo: isDarkMode ? '#8fa0c1' : '#f0f9ff',
                  color: (opacity = 1) => `rgba(37, 99, 235, ${opacity})`,
                  labelColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
                }}
                hideLegend={true}
              />
              <Text style={{
                position: 'absolute',
                width: '100%',
                textAlign: 'center',
                top: 30,
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {Math.round(overallData.caloriesConsumed / overallData.caloriesGoal * 100)}%
              </Text>
            </View>
          </View>
          
          <Text style={{
            fontSize: 14,
            color: isDarkMode ? '#e0e0e0' : '#4b5563',
            fontStyle: 'italic',
          }}>
            {overallData.caloriesConsumed < overallData.caloriesGoal * 0.8 
              ? '注意：您的卡路里摄入较低，可能影响身体所需能量。' 
              : overallData.caloriesConsumed > overallData.caloriesGoal * 1.1
                ? '注意：您的卡路里摄入超出目标较多，请注意控制饮食。'
                : '您的卡路里摄入在理想范围内，继续保持！'}
          </Text>
        </View>
        
        {/* 营养素摄入平衡评估 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            营养素摄入平衡评估
          </Text>
          
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 16 }}>
            <View style={{ alignItems: 'center' }}>
              <View style={{
                width: 70,
                height: 70,
                borderRadius: 35,
                backgroundColor: '#10b981',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <Text style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>
                  {Math.round(overallData.proteinPercentage * 100)}%
                </Text>
              </View>
              <Text style={{
                marginTop: 8,
                fontSize: 14,
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                蛋白质
              </Text>
            </View>
            
            <View style={{ alignItems: 'center' }}>
              <View style={{
                width: 70,
                height: 70,
                borderRadius: 35,
                backgroundColor: '#f59e0b',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <Text style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>
                  {Math.round(overallData.carbsPercentage * 100)}%
                </Text>
              </View>
              <Text style={{
                marginTop: 8,
                fontSize: 14,
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                碳水化合物
              </Text>
            </View>
            
            <View style={{ alignItems: 'center' }}>
              <View style={{
                width: 70,
                height: 70,
                borderRadius: 35,
                backgroundColor: '#ec4899',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <Text style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>
                  {Math.round(overallData.fatPercentage * 100)}%
                </Text>
              </View>
              <Text style={{
                marginTop: 8,
                fontSize: 14,
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                脂肪
              </Text>
            </View>
            
            <View style={{ alignItems: 'center' }}>
              <View style={{
                width: 70,
                height: 70,
                borderRadius: 35,
                backgroundColor: '#8b5cf6',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <Text style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>
                  {Math.round(overallData.fiberPercentage * 100)}%
                </Text>
              </View>
              <Text style={{
                marginTop: 8,
                fontSize: 14,
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                膳食纤维
              </Text>
            </View>
          </View>
          
          <Text style={{
            fontSize: 14,
            color: isDarkMode ? '#e0e0e0' : '#4b5563',
          }}>
            整体评估: {overallData.proteinPercentage > 0.8 && overallData.carbsPercentage > 0.8 && overallData.fatPercentage > 0.7 
              ? '您的宏量营养素摄入总体平衡，继续保持多样化饮食。' 
              : '您的部分营养素摄入不足，请关注具体建议中的食物搭配建议。'}
          </Text>
        </View>
        
        {/* 本周饮食习惯分析 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            本周饮食习惯分析
          </Text>
          
          <View style={{ marginBottom: 16 }}>
            <LineChart
              data={{
                labels: ['一', '二', '三', '四', '五', '六', '日'],
                datasets: [
                  {
                    data: weeklyData.calories.map(cal => cal / overallData.caloriesGoal)
                  }
                ]
              }}
              width={screenWidth - 64}
              height={180}
              chartConfig={{
                backgroundGradientFrom: isDarkMode ? '#8fa0c1' : '#f0f9ff',
                backgroundGradientTo: isDarkMode ? '#8fa0c1' : '#f0f9ff',
                decimalPlaces: 1,
                color: (opacity = 1) => `rgba(59, 130, 246, ${opacity})`,
                labelColor: (opacity = 1) => isDarkMode ? `rgba(255, 255, 255, ${opacity})` : `rgba(31, 41, 55, ${opacity})`,
                style: {
                  borderRadius: 16
                },
                propsForDots: {
                  r: "6",
                  strokeWidth: "2",
                  stroke: isDarkMode ? "#3b82f6" : "#2563eb"
                }
              }}
              bezier
              style={{
                marginVertical: 8,
                borderRadius: 16
              }}
              fromZero
              withInnerLines={false}
              yAxisSuffix="%"
              yAxisLabel=""
              yLabelsOffset={10}
              segments={4}
            />
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              textAlign: 'center',
              marginTop: 4,
            }}>
              本周卡路里摄入达成率
            </Text>
          </View>
          
          <View style={{ marginBottom: 8 }}>
            {renderHabitItem('规律进餐', overallData.weeklyHabits.regularMeals)}
            {renderHabitItem('饮食多样性', overallData.weeklyHabits.mealVariety)}
            {renderHabitItem('充分饮水', overallData.weeklyHabits.hydration)}
            {renderHabitItem('避免深夜进食', overallData.weeklyHabits.lateNightEating)}
          </View>
        </View>
        
        {/* 健康风险提示 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            健康风险提示
          </Text>
          
          {overallData.healthRisks.length > 0 ? (
            overallData.healthRisks.map((risk, index) => (
              <View key={index} style={{
                backgroundColor: 
                  risk.severity === 'high' ? 'rgba(239, 68, 68, 0.15)' : 
                  risk.severity === 'moderate' ? 'rgba(245, 158, 11, 0.15)' : 
                  'rgba(16, 185, 129, 0.15)',
                borderRadius: 12,
                padding: 12,
                marginBottom: index < overallData.healthRisks.length - 1 ? 12 : 0,
                borderLeftWidth: 4,
                borderLeftColor: 
                  risk.severity === 'high' ? '#ef4444' : 
                  risk.severity === 'moderate' ? '#f59e0b' : 
                  '#10b981',
              }}>
                <Text style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: 
                    risk.severity === 'high' ? '#ef4444' : 
                    risk.severity === 'moderate' ? '#f59e0b' : 
                    '#10b981',
                  marginBottom: 4,
                }}>
                  {risk.title}
                </Text>
                <Text style={{
                  fontSize: 14,
                  color: isDarkMode ? '#e0e0e0' : '#4b5563',
                }}>
                  {risk.description}
                </Text>
              </View>
            ))
          ) : (
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              fontStyle: 'italic',
            }}>
              未发现明显健康风险，继续保持健康饮食习惯！
            </Text>
          )}
        </View>
        
        {/* 改进建议概要 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            改进建议概要
          </Text>
          
          <View style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 12,
          }}>
            <View style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: '#3b82f6',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 12,
            }}>
              <Ionicons name="nutrition" size={20} color="white" />
            </View>
            <Text style={{
              flex: 1,
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              增加高蛋白质食物摄入，如鱼类、瘦肉和豆制品
            </Text>
          </View>
          
          <View style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 12,
          }}>
            <View style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: '#10b981',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 12,
            }}>
              <Ionicons name="leaf" size={20} color="white" />
            </View>
            <Text style={{
              flex: 1,
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              多摄入富含维生素D的食物，如蛋黄、鱼肝油和奶制品
            </Text>
          </View>
          
          <View style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 12,
          }}>
            <View style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: '#f59e0b',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 12,
            }}>
            <Ionicons name="water" size={20} color="white" />
            </View>
            <Text style={{
              flex: 1,
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              减少钠的摄入，选择清淡烹饪方式，少吃加工食品
            </Text>
          </View>
          
          <View style={{
            flexDirection: 'row',
            alignItems: 'center',
          }}>
            <View style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: '#ec4899',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 12,
            }}>
              <Ionicons name="time" size={20} color="white" />
            </View>
            <Text style={{
              flex: 1,
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              避免晚上8点后进食，保持规律的三餐时间
            </Text>
          </View>
        </View>
      </View>
    );
  }

  // 渲染饮食习惯项
  function renderHabitItem(title, percentage) {
    return (
      <View style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
      }}>
        <Text style={{
          width: 120,
          fontSize: 14,
          color: isDarkMode ? '#e0e0e0' : '#4b5563',
        }}>
          {title}
        </Text>
        <View style={{
          flex: 1,
          height: 8,
          backgroundColor: isDarkMode ? '#637394' : '#e0e7ff',
          borderRadius: 4,
          overflow: 'hidden',
        }}>
          <View style={{
            width: `${percentage * 100}%`,
            height: '100%',
            backgroundColor: percentage < 0.6 ? '#ef4444' : 
                             percentage < 0.8 ? '#f59e0b' : '#10b981',
            borderRadius: 4,
          }} />
        </View>
        <Text style={{
          width: 40,
          textAlign: 'right',
          fontSize: 14,
          color: isDarkMode ? '#e0e0e0' : '#4b5563',
          marginLeft: 8,
        }}>
          {Math.round(percentage * 100)}%
        </Text>
      </View>
    );
  }

  // 渲染具体建议标签内容
  function renderDetailsTab() {
    const { recommendedFoods } = nutritionData;
    
    return (
      <View>
        {/* 营养素补充建议 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 16,
          }}>
            营养素补充建议
          </Text>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#10b981',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="fitness" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                蛋白质、脂肪、碳水化合物
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 增加优质蛋白质摄入，目标85-95克/天，推荐鸡胸肉、三文鱼、豆腐
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 控制精制碳水化合物，选择全谷物和低GI食物，如燕麦、糙米
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 适量增加健康脂肪摄入，如坚果、橄榄油和牛油果
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#f59e0b',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="leaf" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                维生素和矿物质
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 增加维生素D摄入，通过食用蛋黄、奶酪和鱼肝油，建议每日适当晒太阳
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 补充维生素C，每日摄入柑橘类水果、猕猴桃或彩椒
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 注意钙的摄入，建议每日300ml牛奶或等量乳制品，搭配绿叶蔬菜
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#8b5cf6',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="git-branch" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                膳食纤维
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 目前膳食纤维摄入不足，建议增加至每日25-30克
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 增加全谷物、豆类和坚果的摄入
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 每餐增加蔬菜量，保证每日摄入500g蔬果
            </Text>
          </View>
        </View>
        
        {/* 食物搭配建议 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 16,
          }}>
            食物搭配建议
          </Text>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#0d9488',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="restaurant" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                推荐食物组合
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 早餐：全麦面包 + 鸡蛋 + 牛奶 + 蓝莓
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 午餐：糙米饭 + 三文鱼 + 西兰花 + 菠菜
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 晚餐：藜麦 + 鸡胸肉 + 混合蔬菜 + 一小碗水果
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#0ea5e9',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="swap-horizontal" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                食材替换建议
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 用红薯替代白米饭，提供更多膳食纤维和维生素
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 选择希腊酸奶替代普通酸奶，获取更多蛋白质
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 使用橄榄油替代其他烹饪油，提供健康脂肪酸
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#ec4899',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="color-palette" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                食物多样性建议
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 每周尝试2-3种新鲜食材，增加饮食多样性
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 食用不同颜色的蔬果，确保摄入多种植物营养素
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 轮换蛋白质来源，如鱼类、禽类、豆类和蛋
            </Text>
          </View>
        </View>
        
        {/* 饮食习惯改进 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 16,
          }}>
            饮食习惯改进
          </Text>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#3b82f6',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="time" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                进餐时间建议
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 早餐：7:00-8:30，保证充足营养开始一天
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 午餐：12:00-13:30，避免过晚导致下午能量不足
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 晚餐：18:00-19:30，避免睡前3小时内进食
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#f59e0b',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="resize" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                食物份量控制建议
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 使用小号餐盘，视觉上增加满足感
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 碳水化合物控制在拳头大小，蛋白质控制在手掌大小
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 细嚼慢咽，给饱腹感反应时间，避免过量进食
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#ef4444',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="warning" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                不良饮食习惯提醒
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 避免边看手机/电视边进食，容易导致摄入过量
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 减少加工食品和高钠食品摄入，如方便面、腌制食品
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 避免过度饥饿后进食，容易导致暴饮暴食
            </Text>
          </View>
        </View>
        
        {/* 个性化运动建议 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 16,
          }}>
            个性化运动建议
          </Text>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#10b981',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="flame" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                基于摄入的运动消耗建议
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 今日卡路里盈余：180千卡，建议30分钟中等强度运动
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 本周平均需要消耗：220千卡/天，建议增加有氧运动
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 周末可安排高强度间歇训练，消耗更多热量
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
            marginBottom: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#8b5cf6',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="fitness" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                运动类型推荐
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 有氧运动：快走、游泳、骑自行车，每周3-4次
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 力量训练：哑铃、弹力带练习，每周2-3次，增加基础代谢
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 灵活性训练：瑜伽、拉伸，每周1-2次，改善肌肉平衡
            </Text>
          </View>
          
          <View style={{
            backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
            borderRadius: 12,
            padding: 12,
          }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <View style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: '#0ea5e9',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 12,
              }}>
                <Ionicons name="stats-chart" size={20} color="white" />
              </View>
              <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                运动强度和时长建议
              </Text>
            </View>
            
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 低强度（步行、轻度瑜伽）：每次45-60分钟
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              marginBottom: 8,
            }}>
              • 中强度（快走、骑车）：每次30-40分钟
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
            }}>
              • 高强度（跑步、HIIT）：每次20-25分钟
            </Text>
          </View>
        </View>
        
        {/* 推荐食物 */}
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          borderRadius: 16,
          padding: 16,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 16,
          }}>
            为您推荐的食物
          </Text>
          
          {recommendedFoods.map((food) => (
            <View
              key={food.id}
              style={{
                flexDirection: 'row',
                backgroundColor: isDarkMode ? '#99a9c4' : '#eff6ff',
                borderRadius: 12,
                padding: 12,
                marginBottom: 12,
                alignItems: 'center',
              }}
            >
              <Image
                source={{ uri: food.image }}
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  marginRight: 16,
                }}
              />
              <View style={{ flex: 1 }}>
                <Text style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: isDarkMode ? 'white' : '#1f2937',
                  marginBottom: 4,
                }}>
                  {food.name}
                </Text>
                <Text style={{
                  fontSize: 14,
                  color: isDarkMode ? '#e0e0e0' : '#4b5563',
                }}>
                  {food.benefit}
                </Text>
              </View>
              <TouchableOpacity
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 20,
                  backgroundColor: '#3b82f6',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onPress={() => navigation.navigate('FoodSearch', { query: food.name })}
              >
                <Ionicons name="search" size={20} color="white" />
              </TouchableOpacity>
            </View>
          ))}
          
          <TouchableOpacity
            style={{
              flexDirection: 'row',
              backgroundColor: isDarkMode ? '#2563eb' : '#3b82f6',
              borderRadius: 12,
              padding: 16,
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 8,
            }}
            onPress={() => navigation.navigate('FoodSearch')}
          >
            <Ionicons name="search" size={20} color="white" style={{ marginRight: 8 }} />
            <Text style={{
              fontSize: 16,
              fontWeight: 'bold',
              color: 'white',
            }}>
              探索更多食物
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
};

export default FoodRecommendationScreen; 